module.exports = __webpack_public_path__ + "static/media/selectra-kelwatt.8d3c9327.webp";